export const Six = 'i';